const script = document.currentScript;
const preferenceKey = 'mystic-inside-language-selected';

if (script) {
  document.addEventListener(
    'change',
    (event) => {
      if (event.target instanceof HTMLSelectElement && event.target.name === 'language_code') {
        try {
          localStorage.setItem(preferenceKey, 'true');
        } catch (error) {
          console.warn('Could not save the manually selected language preference.', error);
        }
      }
    },
    true
  );

  let languageSelectedManually = false;
  try {
    languageSelectedManually = localStorage.getItem(preferenceKey) === 'true';
  } catch (error) {
    languageSelectedManually = true;
    console.warn('Automatic language selection is disabled because browser storage is unavailable.', error);
  }

  if (!languageSelectedManually) {
    const availableLocales = JSON.parse(script.dataset.availableLocales || '[]');
    const browserLocales = navigator.languages?.length ? navigator.languages : [navigator.language];
    const matchingLocale = browserLocales
      .map((locale) => locale.toLowerCase())
      .map((preferredLocale) => {
        const exactMatch = availableLocales.find((locale) => locale.toLowerCase() === preferredLocale);
        return exactMatch || availableLocales.find((locale) => locale.split('-')[0].toLowerCase() === preferredLocale.split('-')[0]);
      })
      .find(Boolean);

    if (matchingLocale && matchingLocale !== script.dataset.currentLocale) {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = script.dataset.localizationUrl;

      for (const [name, value] of [
        ['language_code', matchingLocale],
        ['return_to', script.dataset.returnTo || '/'],
      ]) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.append(input);
      }

      document.body.append(form);
      form.submit();
    }
  }
}
